import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { MsgBoxType, ToastService } from '@ui';
import { SharedActions } from '../state/shared/shared.actions';

export const showMessage$ = createEffect(
  (actions$ = inject(Actions), toastService = inject(ToastService)) =>
    actions$.pipe(
      ofType(SharedActions.showMessage),
      tap(({ error, warning, success, info }) => {
        if (error) {
          toastService.showCustomAlert(error, MsgBoxType.ERROR);
        }
        if (warning) {
          toastService.showCustomAlert(warning, MsgBoxType.WARNING);
        }
        if (success) {
          toastService.showCustomAlert(success, MsgBoxType.SUCCESS);
        }
        if (info) {
          toastService.showCustomAlert(info, MsgBoxType.INFO);
        }
      }),
    ),
  { functional: true, dispatch: false },
);
